"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CategoriesSideBarSection = void 0;
var categories_sidebar_section_component_1 = require("./categories-sidebar-section.component");
Object.defineProperty(exports, "CategoriesSideBarSection", { enumerable: true, get: function () { return categories_sidebar_section_component_1.CategoriesSideBarSection; } });
